'use strict';

const jQuery = require('jquery');

const Dnd = require('./../../../services/dnd');
const container = require('./../../../core/container');

const areaSize = 10;
let isDisabled = false;

const buildZone = function(config) {
  let mainClass = config.mainClass || 'cloud-dnd';
  let $zone = jQuery('<div class="' + config.className + ' ' + mainClass + '"></div>');

  $zone.css('top', config.top);
  $zone.css('left', config.left);

  if (config.setHeight !== false) {
    $zone.css('height', (config.height || areaSize) + 'px');
  }

  if (config.paddingLeft) {
    $zone.css('padding-left', config.paddingLeft);
  }

  if (config.paddingRight) {
    $zone.css('padding-right', config.paddingRight);
  }

  if (config.setWidth !== false) {
    $zone.css('width', (config.width || areaSize) + 'px');
  }

  if (undefined !== config.right) {
    $zone.css('right', config.right);
  }

  if (undefined !== config.bottom) {
    $zone.css('bottom', config.bottom);
  }

  config.$content[config.to]($zone);

  return $zone;
};

const applyHorizontal = function() {
  let dndConfig = {
    'hoverClass': 'drop-hover',
    'tolerance': 'pointer',
    'accept': function($target) {
      let $colContentSet = $target.parents('.colcontentset:first');
      let $cloudContentSet = $target.parents('.cloudcontentset:first');
      let $current = jQuery(this);

      if ($target.hasClass('cloud-dialog') || $target.hasClass('ui-sortable-helper')) {
        return false;
      }

      if ($colContentSet.parent('div').siblings().not('.cloud-dnd, .cloud-column-resize, .cloud-dnd-content').length === 0) {
        if ($current.prev().is($cloudContentSet) || $current.next().is($cloudContentSet)) {
          return false;
        }
      }

      return true;
    },
  };
  let $rootContentSet = jQuery('.rootContentSet');
  let $children = $rootContentSet.children('.cloudcontentset');

  if (!$children.length) {
    let $zone = buildZone({
      '$content': $rootContentSet,
      'to': 'append',
      'className': 'horizontal cloud-default-dnd container fixed force-fixed',
      'height': '10px',
      'setWidth': false,
    });

    $zone.css({'margin-top': '20px', 'position': 'initial'});

    Dnd.droppable($zone, 'block', dndConfig);

    $zone.mouseenter();
  } else {
    $children.each(function(key) {
      let $cloudContentset = jQuery(this);
      let position = $cloudContentset.position();
      let $zone;

      if (0 === key) {
        $zone = buildZone({
          '$content': $cloudContentset,
          'to': 'before',
          'className': 'horizontal',
          'top': position.top + areaSize / 2,
          'height': areaSize,
          'left': '25%',
          'right': '25%',
          'setWidth': false,
        });

        Dnd.droppable($zone, 'block', dndConfig);
      }

      let top = position.top + $cloudContentset.outerHeight(true) - areaSize;

      $zone = buildZone({
        '$content': $cloudContentset,
        'to': 'after',
        'className': 'horizontal',
        'top': top,
        'height': areaSize,
        'left': '25%',
        'right': '25%',
        'setWidth': false,
      });

      $zone.css('margin-top', '10px');

      Dnd.droppable($zone, 'block', dndConfig);
    });
  }
};

const applyVertical = function() {
  let dndConfig = {
    'hoverClass': 'drop-hover',
    'tolerance': 'pointer',
    'accept': function($target) {
      let $colContentSet = $target.parents('.colcontentset:first');
      let $cloudContentSet = $target.parents('.cloudcontentset:first');
      let $parent = $colContentSet.parent('div');
      let $current = jQuery(this);

      if ($target.hasClass('cloud-dialog') || $target.hasClass('ui-sortable-helper')) {
        return false;
      }

      if ($parent.prev().is($current) || $parent.next().is($current)) {
        if ($colContentSet.children().not('.cloud-dnd, .cloud-dnd-content, .cloud-column-resize, .ghost-dnd').length === 1) {
          return false;
        }
      }

      if ($current.siblings('div').not('.cloud-dnd, .cloud-column-resize, .cloud-dnd-content').length >= 4) {
        if (!$cloudContentSet.is($current.parents('.cloudcontentset:first'))) {
          return false;
        }

        if ($target.siblings('.bb-content').not('.ghost-dnd').length) {
          return false;
        }
      }

      return true;
    },
  };

  jQuery('.cloudcontentset').find('.row:first').each(function() {
    let $row = jQuery(this);
    let $container = $row.parent();
    let $children = $row.children(':not(.cloud-dnd-content)');
    let length = $children.length;

    $children.each(function(key) {
      let $col = jQuery(this);
      let position = $col.position();
      let $zone;
      let left;

      if (0 === key) {
        left = -(parseInt($container.css('margin-left').replace('px', ''), 10) / 2);

        $zone = buildZone({
          '$content': $col,
          'to': 'before',
          'className': 'vertical left',
          'mainClass': 'cloud-dnd-content',
          'top': 0,
          'bottom': 0,
          'left': left,
          'width': (-left) + ($col.width() * 0.25),
          'setHeight': false,
        });

        Dnd.droppable($zone, 'block', dndConfig);
      }

      if (key === length - 1) {
        left = position.left + $col.outerWidth() * 0.75;

        $zone = buildZone({
          '$content': $col,
          'to': 'after',
          'className': 'vertical right',
          'mainClass': 'cloud-dnd-content',
          'top': 0,
          'bottom': 0,
          'left': left,
          'width': ($col.outerWidth() * 0.25) + (parseInt($container.css('margin-right').replace('px', ''), 10) / 2),
          'setHeight': false,
        });

        Dnd.droppable($zone, 'block', dndConfig);
      } else {
        let $nextCol = $col.nextAll('div:not(.cloud-dnd-content):first');
        let $prevsCol = $col.prevAll('div:not(.cloud-dnd-content):first');
        let colWidth = $col.outerWidth();
        let left = colWidth * 0.75;

        $prevsCol.each(function() {
          let $current = jQuery(this);

          left = left + $current.outerWidth();
        });

        $zone = buildZone({
          '$content': $col,
          'to': 'after',
          'className': 'vertical middle',
          'mainClass': 'cloud-dnd-content',
          'top': 0,
          'left': left + 'px',
          'width': (colWidth * 0.25) + ($nextCol.outerWidth() * 0.25),
          'bottom': 0,
          'setHeight': false,
        });

        Dnd.droppable($zone, 'block', dndConfig);
      }
    });
  });
};

const getOuter = function($content, position) {
  if ($content.hasClass('has-image-placeholder')) {
    return 0;
  }

  return parseInt($content.css(`padding-${position}`).replace('px', ''), 10) + parseInt($content.css(`margin-${position}`).replace('px', ''), 10);
};

const getMaxTopDndZone = function($row) {
  let $dndZones = $row.find('.between.last');
  let top = 0;

  if ($dndZones.length === 1) {
    return null;
  }

  $dndZones.each(function() {
    let currentTop = parseInt(jQuery(this).css('top').replace('px', ''), 10);
    if (currentTop > top) {
      top = currentTop;
    }
  });

  return top;
};

const applyHorizontalBetweenContent = function() {
  jQuery('.colcontentset').each(function() {
    let $colContentset = jQuery(this);
    let $cloudContentset = $colContentset.parents('.cloudcontentset:first');
    let $row = $colContentset.parents('.row:first');

    if ($colContentset.parents('.row:first').find('.colcontentset').length < 1) {
      return;
    }

    let length = $colContentset.children('.bb-content').length;
    $colContentset.children('.bb-content').each(function(key) {
      let $content = jQuery(this);
      let $nextContent = $content.nextAll('.bb-content:first');
      let position = $content.position();

      if (0 === key) {
        buildZone({
          '$content': $content,
          'to': 'before',
          'className': 'horizontal between',
          'top': 0,
          'height': areaSize,
          'left': 0,
          'right': 0,
          'setWidth': false,
        });
      }

      let outerNext = 0;
      if ($nextContent.length && !$nextContent.hasClass('media-image')) {
        outerNext = getOuter($nextContent, 'top') + 10;
      }

      let top = position.top + $content.height() + getOuter($content, 'top') + ((getOuter($content, 'bottom') + outerNext) / 2);
      if ($content.hasClass('has-image-placeholder')) {
        top = position.top + $content.find('.cloud-placeholder').height();
      }

      buildZone({
        '$content': $content,
        'to': 'after',
        'className': 'horizontal between ' + (((key + 1) === length) ? 'last' : ''),
        'height': areaSize,
        'left': 0,
        'right': 0,
        'top': top,
        'setWidth': false,
      });
    });

    let maxTop = getMaxTopDndZone($row);
    if (null !== maxTop) {
      $row.find('.between.last').each(function() {
        let $current = jQuery(this);
        let currentTop = parseInt($current.css('top').replace('px', ''), 10);

        if (currentTop < maxTop) {
          let division = $cloudContentset.hasClass('align-item-center') ? 2 : 1;
          $current.css('height', (areaSize + (maxTop - currentTop)) / division);
        }
      });
    }
  });
};

module.exports.destroy = function() {
  jQuery('.cloud-dnd, .cloud-dnd-content').remove();
};

module.exports.hideAll = function() {
  if (!container.get('isMobile')) {
    jQuery('.cloud-dnd, .cloud-dnd-content').addClass('d-none');
  }
};

const getContentHeight = ($content) => {
  if ($content.hasClass('media-image')) {
    let $img = $content.find('img');

    if (!$img.length) {
      $img = $content.find('.cloud-placeholder');
    }

    return $img.height();
  }

  return $content.height();
};

module.exports.applyDnd = () => {
  let dndConfig = {
    'hoverClass': 'drop-hover',
    'tolerance': 'pointer',
    'accept': function($content, data) {
      let $zone = jQuery(this);

      if ($content.hasClass('cloud-dialog') || $content.hasClass('ui-sortable-helper')) {
        return false;
      }

      if ($zone.prevAll('.bb-content:first').is($content)) {
        return false;
      }

      if ($zone.nextAll('.bb-content:first').is($content)) {
        return false;
      }

      return true;
    },
  };

  jQuery('.colcontentset').each(function() {
    let $colContentset = jQuery(this);

    if ($colContentset.parents('.row:first').find('.colcontentset').length === 1) {
      return;
    }

    let $contents = $colContentset.children('.bb-content');

    $contents.each(function(key) {
      let $content = jQuery(this);
      let $prevContent = $content.prevAll('.bb-content:first');
      let $nextContent = $content.nextAll('.bb-content:first');
      let contentPosition = $content.position();
      let contentHeight = getContentHeight($content);
      let tpl = '<div class="cloud-dnd-content horizontal-between"></div>';
      let $prevAddZone = $content.prev('.horizontal.between');
      let $nextAddZone = $content.next('.horizontal.between');

      if (!$prevContent.length) {
        let $zone = jQuery(tpl);

        $zone.css({
          'left': '25%',
          'right': '25%',
          'top': 0,
          'height': (contentHeight / 2) - 1,
        });

        $zone.addClass('first');

        $prevAddZone.before($zone);
        Dnd.droppable($zone, 'block', dndConfig);
      } else {
        let $zone = jQuery(tpl);
        let prevContentPosition = $prevContent.position();
        let prevContentHeight = getContentHeight($prevContent);
        let top = prevContentPosition.top + (prevContentHeight / 2);

        $zone.css({
          'left': '25%',
          'right': '25%',
          'top': top + 1,
          'height': (contentPosition.top + (contentHeight / 2)) - top - 1,
        });

        $prevAddZone.before($zone);
        Dnd.droppable($zone, 'block', dndConfig);
      }

      if (!$nextContent.length) {
        let $zone = jQuery(tpl);
        let nextAddZonePosition = $nextAddZone.position();
        let top = contentPosition.top + (contentHeight / 2) + 1;

        $zone.css({
          'left': '25%',
          'right': '25%',
          'top': top,
          'height': $nextAddZone.height() + (nextAddZonePosition.top - top),
          'setHeight': false,
        });

        $zone.addClass('last');

        $nextAddZone.before($zone);
        Dnd.droppable($zone, 'block', dndConfig);
      }
    });
  });
};

module.exports.onDropOver = function(data) {
  let $zone = jQuery(data.$element);

  $zone.addClass('drop-hover');

  if ($zone.hasClass('cloud-dnd-content')) {
    if ($zone.hasClass('vertical')) {
      let $leftContent = $zone.prevAll('div:not(.cloud-dnd-content):first');

      if ($leftContent.length) {
        $leftContent.addClass('insert-content-right');
      } else {
        let $rightContent = $zone.nextAll('div:not(.cloud-dnd-content):first');
        if ($rightContent.length) {
          $rightContent.addClass('insert-content-left');
        }
      }
    }
  }
};

module.exports.onDropOut = function(data) {
  let $zone = jQuery(data.$element);

  $zone.removeClass('drop-hover');
  $zone.siblings().removeClass('insert-content-left insert-content-right');
  jQuery('.dnd-hover').removeClass('dnd-hover');
};

module.exports.apply = function() {
  if (isDisabled ||
    jQuery('.cloud-cke').length ||
    container.get('isMobile') === true ||
    !container.get('isAllowedTo')('CREATE_CONTENT')
  ) {
    return;
  }

  module.exports.destroy();

  if (container.get('ui-enable-dnd-only-horizontal-between-content')) {
    applyHorizontalBetweenContent();
    applyHorizontal();
  } else {
    applyVertical();
    applyHorizontal();
    applyHorizontalBetweenContent();
  }

  setTimeout(function() {
    jQuery('.horizontal-between').remove();
    module.exports.applyDnd();
  }, 10);
};

module.exports.disable = () => {
  module.exports.destroy();
  isDisabled = true;
};

module.exports.enable = () => {
  isDisabled = false;
  module.exports.apply();
};

window.dndZone = {
  'apply': module.exports.apply,
};
